import { currentClient } from '@alli/frontend-common';
import getClient from './getClient';

export default function setCurrentClient(client) {
    if (!client) {
        currentClient.next(null);
        return;
    }

    const finalClient = {
        ...client,
        refresh: () =>
            getClient(client.slug).then(client => {
                setCurrentClient(client);
                return client;
            }),
    };

    currentClient.next(finalClient);
}
